"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBarNotification = void 0;
const react_1 = __importStar(require("react"));
const AppBarNotificationControl_1 = require("./components/AppBarNotificationControl/AppBarNotificationControl");
const AppBarNotificationPopover_1 = require("./components/AppBarNotificationPopover/AppBarNotificationPopover");
const Dropdown_1 = require("../../../controls/Dropdown");
const helpers_1 = require("../../../helpers");
const Popover_1 = require("../../../Popover");
exports.AppBarNotification = (0, helpers_1.createUIElement)('AppBarNotification', (_a, ref) => {
    var { className, noAutoDisplay = false, shownState = false, messages = [], unread = false, empty = false, isAutoDisplay = false, onAutoDisplayChange, onClearAllClick, onDidHide, onDidShow, texts, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, virtualization, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "noAutoDisplay", "shownState", "messages", "unread", "empty", "isAutoDisplay", "onAutoDisplayChange", "onClearAllClick", "onDidHide", "onDidShow", "texts", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", "virtualization", 'data-selector-id']);
    const buttonRef = ref !== null && ref !== void 0 ? ref : (0, react_1.useRef)(null);
    const isEmpty = (0, react_1.useMemo)(() => empty || !messages.length, [empty, messages.length]);
    const showClearAll = (0, react_1.useMemo)(() => Boolean(onClearAllClick), [onClearAllClick]);
    const isFooterEnabled = (0, react_1.useMemo)(() => showClearAll || !noAutoDisplay, [noAutoDisplay, showClearAll]);
    const emptyText = (0, react_1.useMemo)(() => (texts === null || texts === void 0 ? void 0 : texts.empty) || 'No notifications', [texts === null || texts === void 0 ? void 0 : texts.empty]);
    const clearAllText = (0, react_1.useMemo)(() => (texts === null || texts === void 0 ? void 0 : texts.clearAll) || 'Clear All', [texts === null || texts === void 0 ? void 0 : texts.clearAll]);
    const autoDisplayText = (0, react_1.useMemo)(() => (texts === null || texts === void 0 ? void 0 : texts.autoDisplay) || 'Auto-display new messages', [texts === null || texts === void 0 ? void 0 : texts.autoDisplay]);
    const initialActiveState = (0, react_1.useMemo)(() => !noAutoDisplay && shownState, [noAutoDisplay, shownState]);
    const [element] = (0, Dropdown_1.useDropdown)({
        ref: buttonRef,
        initialActiveState,
        onDidHide,
        onDidShow,
        popoverConfig: [
            { xAxis: Popover_1.X_AXIS.insideRight, yAxis: Popover_1.Y_AXIS.outsideBottom },
            { xAxis: Popover_1.X_AXIS.insideLeft, yAxis: Popover_1.Y_AXIS.outsideBottom }
        ],
        renderControl: ({ button, isActive }) => (react_1.default.createElement(AppBarNotificationControl_1.AppBarNotificationControl, Object.assign({}, rest, { button: button, unread: unread, isEmpty: isEmpty, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, "data-selector-id": initialDataSelectorId, isActive: isActive, style: style, className: className }))),
        renderContent: () => {
            return (react_1.default.createElement(AppBarNotificationPopover_1.AppBarNotificationPopover, { messages: messages, emptyText: emptyText, isEmpty: isEmpty, isFooterEnabled: isFooterEnabled, virtualization: virtualization, showClearAll: showClearAll, noAutoDisplay: noAutoDisplay, isAutoDisplay: isAutoDisplay, onClearAllClick: onClearAllClick, onAutoDisplayChange: onAutoDisplayChange, clearAllText: clearAllText, autoDisplayText: autoDisplayText }));
        }
    });
    return element;
});
//# sourceMappingURL=AppBarNotification.js.map